import { useState } from "react";
import { SecurityTeamList } from "./SecurityTeamList";

export default {
  title: "SecurityPortal/Events/SecurityTeamList",
  component: SecurityTeamList,
  decorators: [
    (Story) => (
      <div
        style={{
          fontFamily: "Helvetica Neue",
          width: "554px",
          fontSize: "10px",
          height: "300px",
        }}
      >
        <Story />
      </div>
    ),
  ],
};

const Template = (args) => {
  const [securityTeamList, setSecurityTeamList] = useState(
    args.securityTeamList
  );

  const onPin = (pinStatus, team) => {
    const newList = [];
    let editedTeam;

    // When unpinned, the item is returned at the end of the list.
    // When pinned, the item is returned at the top of the list.
    securityTeamList.forEach((_team) => {
      if (_team.email === team.email) {
        editedTeam = { ...team, pinned: pinStatus };
      } else newList.push(_team);
    });

    pinStatus ? newList.unshift(editedTeam) : newList.push(editedTeam);
    setSecurityTeamList(newList);
  };

  return (
    <SecurityTeamList
      {...args}
      onPin={onPin}
      securityTeamList={securityTeamList}
    />
  );
};

const ExampleTeam = {
  pinned: false,
  name: "Last, First",
  phoneNumber: "000-000-0000",
  email: "name@email.com",
  CCW: true,
};

export const Default = Template.bind({});
Default.args = {
  securityTeamList: [
    ExampleTeam,
    { ...ExampleTeam, pinned: true, email: ExampleTeam.email + 1 },
    { ...ExampleTeam, pinned: true, email: ExampleTeam.email + 2 },
    { ...ExampleTeam, pinned: true, CCW: false, email: ExampleTeam.email + 3 },
    { ...ExampleTeam, CCW: false, email: ExampleTeam.email + 4 },
    { ...ExampleTeam, email: ExampleTeam.email + 5 },
    { ...ExampleTeam, email: ExampleTeam.email + 6 },
    { ...ExampleTeam, email: ExampleTeam.email + 7 },
    { ...ExampleTeam, email: ExampleTeam.email + 8 },
    { ...ExampleTeam, email: ExampleTeam.email + 9 },
    { ...ExampleTeam, email: ExampleTeam.email + 10 },
    { ...ExampleTeam, email: ExampleTeam.email + 11 },
  ],
  header: "Security Team",
};
